/**
 * GMA-1627 (CompassCare Web 12/14) — Messages route container.
 *
 * Mounts the app-shell (WebShell) around the Messages screen (MessagesPage)
 * at /web/messages, wiring sidebar navigation to the router and the linked-
 * alert context card to /web/alerts. This is the route scaffolding: the live
 * thread/broadcast feeds (real data from the API) are a deliberate follow-up,
 * so until then the page renders the demo hub in demo builds and its
 * fail-safe empty states otherwise, inside a real, navigable frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import MessagesPage from "./MessagesPage";
import { DEMO_DATA_ENABLED, getDemoMessages } from "./demoData";

export default function WebMessagesRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so the demo dataset and the `now` prop agree —
  // relative-time UI drifts if each call reads the clock separately.
  const now = Date.now();
  const demo = DEMO_DATA_ENABLED ? getDemoMessages(now) : null;
  return (
    <WebShell
      activeKey="messages"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Messages"
    >
      <MessagesPage
        threads={demo ? demo.threads : []}
        caregivers={demo ? demo.caregivers : []}
        familyContacts={demo ? demo.familyContacts : []}
        familyVisibility={demo ? demo.familyVisibility : {}}
        cohorts={demo ? demo.cohorts : []}
        recentBroadcasts={demo ? demo.recentBroadcasts : []}
        now={now}
        onOpenAlert={() => navigate("/web/alerts")}
      />
    </WebShell>
  );
}
